const state = {
  tableData: {}
};

export default {
  state
};
